<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">掲載候補商品検索</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">商品案内用商品名</label>
          <div class="list-input-content">
            <app-text-input id="txti_GuideGoodsName" #txti_GuideGoodsName [subid]="'txti_GuideGoodsName'"
              [(ngModel)]="guideGoodsName" [restrict]="'[ -￮]'" [displayCountField]="false" [fullOnly]="true"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-text-input>
          </div>

          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content pcode-wrapper">
            <textarea id="txta_PCodes" [(ngModel)]="pcodes" plessInputTextSub [restrict]="'[P0-9\n]'" [maxlength]="9000"
              forcedEnabledMode="true" [tabindex]="0" [style.width.px]="110" [style.height.px]="220"></textarea>
            <label class="pcode-counts">{{pcodeCounts}}件/1000件</label>
          </div>

          <label class="list-input-title">検索対象媒体</label>
          <div class="list-input-content">
            <app-checkbox-label id="chb_OtherMediumTypeFlg" [subid]="'chb_OtherMediumTypeFlg'"
              [(ngModel)]="otherMediumTypeFlg" [label]="'他媒体の商品を含める'" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-checkbox-label>
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content card" id="li_ClassCode" #li_ClassCode [style.overflow-y]="'scroll'"
            style="height:17rem; padding:0 3px; align-items:initial;">
            <ng-template ngFor let-item [ngForOf]="lstClassCode" let-i="index">
              <div class="checkbox-group" [class.selected]="lastClickId === item.code"
                (change)="eventClassCode_CHANGEHandler(item.code, item.selectedValue)">
                <label>
                  <input type="checkbox" [(ngModel)]="item.selectedValue" class="checkbox" forcedEnabledMode="true"
                    [tabindex]="0">{{ item.lbl }}
                </label>
              </div>
            </ng-template>
          </div>

          <label class="list-input-title">業態区分（デイリー）</label>
          <div class="list-input-content">
            <app-code-check-box-list id="li_DailyDiv" #li_DailyDiv [subid]="'li_DailyDiv'" [codeDiv]="'ctp123'"
              [invalidCode]="'00'" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-code-check-box-list>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Search" class="btn-primary" (click)="eventSearch_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">検索</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>